import { render, staticRenderFns } from "./DetailCustomerCrm.vue?vue&type=template&id=7c87790b&scoped=true"
import script from "./DetailCustomerCrm.vue?vue&type=script&lang=js"
export * from "./DetailCustomerCrm.vue?vue&type=script&lang=js"
import style0 from "./DetailCustomerCrm.vue?vue&type=style&index=0&id=7c87790b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87790b",
  null
  
)

export default component.exports